import { connect } from 'react-redux';

import { actionCleanupDiscoverCategoryDetails, actionGetDiscoveryCategoryDetails } from 'store/discover-category/actions';
import DiscoveryCategoriesDetails from './DiscoveryCategoriesDetails';

const mapStateToProps = (state) => ({
  categoryDetailsLoading: state.DiscoverCategory.categoryDetailsLoading,
  categoryDetails: state.DiscoverCategory.categoryDetails,
});

const mapDispatchToProps = ({
  actionGetDiscoveryCategoryDetails,
  actionCleanupDiscoverCategoryDetails,
});

export default connect(mapStateToProps, mapDispatchToProps)(DiscoveryCategoriesDetails);
